module.exports = __webpack_public_path__ + "img/quasi_fatto.bce446a8.svg";